import React from "react";
function soliPendentes(){
   return(
       <div>
       Indisponivel
       </div>
   )
}

export default soliPendentes;